"use strict";Object.defineProperty(exports,"__esModule",{value:!0});exports.default=function(){return"ontouchstart"in window?"touchstart":"click"};
//# sourceMappingURL=clickEvent.js.map
